// src/utils/presets.js

export const LAND_OWNER_BASE_CTX = {
  v: 1,
  persona: "land_owner",

  layers: [
    { id: "parcels", visible: true },
    { id: "leases", visible: true },
    { id: "pads", visible: true },
    { id: "roads", visible: true },
    { id: "wells", visible: true }
  ],

  imagery: [
    {
      datasetKey: "latest.highres",
      visible: true,
      opacity: 0.9
    }
  ],

  filters: {
    well_status: ["producing", "idle"]
  },

  ui: {
    openPanel: "layers"
  }
};

export const MAP_PRESETS = {
  land_owner: LAND_OWNER_BASE_CTX
};